import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { captureReferral } from './utils/referral';
import { usePageTracking } from './utils/usePageTracking';
import GhostwriterLayout from './components/GhostwriterLayout';
import AIGhostwriterLanding from './pages/AIGhostwriterLanding';
import GhostwriterPricing from './pages/GhostwriterPricing';
import GhostwriterHowItWorks from './pages/GhostwriterHowItWorks';
import GhostwriterFAQ from './pages/GhostwriterFAQ';
import GhostwriterAbout from './pages/GhostwriterAbout';
import GhostwriterContact from './pages/GhostwriterContact';
import GhostwriterDashboard from './pages/GhostwriterDashboard';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AffiliateLanding from './pages/AffiliateLanding';
import AffiliateDashboard from './pages/AffiliateDashboard';
import AffiliateTerms from './pages/AffiliateTerms';
import BlogListing from './pages/BlogListing';
import BlogPost from './pages/BlogPost';
import ClubLanding from './pages/ClubLanding';
import ClubDashboard from './pages/ClubDashboard';
import ClubLeaderboard from './pages/ClubLeaderboard';
import OnboardingQuestionnaire from './pages/OnboardingQuestionnaire';
import AdminPanel from './pages/AdminPanel';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import AffiliatePromo from './pages/AffiliatePromo';
import AffiliateRecruit from './pages/AffiliateRecruit';
import AffiliatePortfolio from './pages/AffiliatePortfolio';
import ProjectDetail from './pages/ProjectDetail';
import GrowthHub from './pages/GrowthHub';
import '@/App.css';

function AppContent() {
  useEffect(() => {
    captureReferral();
  }, []);
  usePageTracking();

  return (
    <GhostwriterLayout>
      <Routes>
        <Route path="/" element={<AIGhostwriterLanding />} />
        <Route path="/pricing" element={<GhostwriterPricing />} />
        <Route path="/how-it-works" element={<GhostwriterHowItWorks />} />
        <Route path="/faq" element={<GhostwriterFAQ />} />
        <Route path="/about" element={<GhostwriterAbout />} />
        <Route path="/contact" element={<GhostwriterContact />} />
        <Route path="/ghostwriter/dashboard" element={<GhostwriterDashboard />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/affiliate" element={<AffiliateLanding />} />
        <Route path="/affiliate/dashboard" element={<AffiliateDashboard />} />
        <Route path="/affiliate/terms" element={<AffiliateTerms />} />
        <Route path="/blog" element={<BlogListing />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/club" element={<ClubLanding />} />
        <Route path="/club/dashboard" element={<ClubDashboard />} />
        <Route path="/club/leaderboard" element={<ClubLeaderboard />} />
        <Route path="/get-started" element={<OnboardingQuestionnaire />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/affiliate/promo/:code" element={<AffiliatePromo />} />
        <Route path="/affiliate/recruit/:code" element={<AffiliateRecruit />} />
        <Route path="/affiliate/portfolio" element={<AffiliatePortfolio />} />
        <Route path="/ghostwriter/project/:projectId" element={<ProjectDetail />} />
        <Route path="/club/growth-hub" element={<GrowthHub />} />
      </Routes>
    </GhostwriterLayout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
